export interface KriteriaEtikaBatuk {
  no: number;
  kriteria: string;
  dasar_regulasi: string;
}

export const KRITERIA_ETIKA_BATUK: KriteriaEtikaBatuk[] = [
  {
    no: 1,
    kriteria: "Menutup hidung dan mulut dengan lengan baju bagian dalam",
    dasar_regulasi: "Permenkes 27/2017 Lamp.I; WHO Cough Etiquette 2016"
  },
  {
    no: 2,
    kriteria: "Tisu bekas batuk dan bersin dibuang ke tempat sampah",
    dasar_regulasi: "Permenkes 27/2017 Ps.11; Kepmenkes 1204/2004"
  },
  {
    no: 3,
    kriteria: "Mencuci tangan 6 langkah setelah batuk/bersin",
    dasar_regulasi: "Permenkes 27/2017 Lamp.I; WHO Hand Hygiene"
  },
  {
    no: 4,
    kriteria: "Menggunakan masker bila sedang batuk",
    dasar_regulasi: "Permenkes 27/2017 Lamp.III; Kepmenkes HK.01.07/413/2020"
  }
];

export const KATEGORI_OBSERVEE_OPTIONS = [
  { text: "Pasien", value: "pasien" },
  { text: "Pengunjung", value: "pengunjung" },
  { text: "Dokter", value: "dokter" },
  { text: "Perawat", value: "perawat" },
  { text: "Bidan", value: "bidan" },
  { text: "Petugas Laboratorium", value: "petugas_lab" },
  { text: "Non-Klinis", value: "non_klinis" },
  { text: "Mahasiswa", value: "mahasiswa" },
  { text: "Lainnya", value: "lainnya" }
];

export const METODE_AUDIT_OPTIONS = [
  { text: "Observasi Langsung", value: "observasi_langsung" },
  { text: "Wawancara", value: "wawancara" },
  { text: "Telusur Dokumen", value: "telusur_dokumen" }
];

export const RUANG_OPTIONS = [
  { text: "IGD", value: "igd" },
  { text: "ICU", value: "icu" },
  { text: "OK / Kamar Bedah", value: "ok" },
  { text: "Rawat Inap", value: "rawat_inap" },
  { text: "Rawat Jalan", value: "rawat_jalan" },
  { text: "Poli Gigi", value: "poli_gigi" }
];

export const PENILAIAN_OPTIONS = [
  { text: "Ya", value: "ya", color: "success", icon: "mdi-check-bold" },
  { text: "Tidak", value: "tidak", color: "error", icon: "mdi-close-thick" },
  { text: "N/A", value: "na", color: "grey", icon: "mdi-minus" }
];
